import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
  ButtonBase,
} from "@reusejs/react";
import { useRouter } from "next/router";

export default function PageNotFound() {
  const router = useRouter();
  let sectionHeader = {
    title: "404",
    description: "Something's missing.",
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-12 md:py-24",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={
          <IconTitleDescriptionActionCard
            title={sectionHeader.title}
            description={sectionHeader.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "mt-2 text-center",
              titleStyles:
                "text-6xl text-blue-600 font-extrabold sm:text-9xl leading-none",
              descriptionWrapper: "text-center mt-3 sm:mt-4 max-w-2xl mx-auto",
              descriptionStyles: "text-2xl sm:text-4xl font-extrabold",
            }}
          />
        }
        secondColumnEl={
          <div>
            <div className="mb-6 text-md text-gray-500 sm:text-lg font-normal">
              Sorry, we can't find that page. You'll find lots to explore on the
              home page.
            </div>
            <ButtonBase
              variant="primary"
              label="Back to Homepage"
              onClick={() => router.push("/")}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "",
                padding: "px-4 py-3",
              }}
            />
          </div>
        }
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full",
          secondElWrapperStyles: "w-full text-center max-w-3xl h-full pt-4",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col",
        }}
      />
    </SectionContainerBase>
  );
}
